module.exports = __webpack_public_path__ + "img/coin-one-img.c830c673.png";